<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="con01">
<a id="pageix"></a>
<a id="pagex"></a>
<h2 class="contentsHead"><span class="bold">Contents</span></h2>
<div class="contentsEntry">
<p class="contentsEntryName"><a href="#/ruleyourfreakinretirement_ack01#ack01">Acknowledgments</a></p></div>
<div class="contentsEntry">
<p class="contentsEntryName"><a href="#/ruleyourfreakinretirement_fm01#fm01">Preface</a></p></div>
<div class="contentsEntry">
<p class="contentsEntryName"><a href="#/ruleyourfreakinretirement_fm03#fm03">Introduction</a></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber1"><a href="#/ruleyourfreakinretirement_pt01#pt01"><span class="bold">Part I: Ruling Today, Preparing to Rule Tomorrow</span></a></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber"><a href="#/ruleyourfreakinretirement_pt01#ch01">1. An Honest Assessment</a></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber"><a href="#/ruleyourfreakinretirement_pt01#ch02">2. Your Needs Now and in Retirement</a></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber"><a href="#/ruleyourfreakinretirement_pt01#ch03">3. Creating a Profile and Looking Ahead</a></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber"><a href="#/ruleyourfreakinretirement_pt01#ch04">4. Social Security and Your Retirement</a></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber"><a href="#/ruleyourfreakinretirement_pt01#ch05">5. Saving for College</a></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber"><a href="#/ruleyourfreakinretirement_pt01#ch06">6. Real Estate</a></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber"><a href="#/ruleyourfreakinretirement_pt01#ch07">7. Insurance</a></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber"><a href="#/ruleyourfreakinretirement_pt01#ch08">8. Estate Planning</a></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber1"><span href="#/ruleyourfreakinretirement_pt02#pt02" title="Link target outside of Sample"><span class="bold">Part II: Mastering the Tools</span></span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber"><span href="#/ruleyourfreakinretirement_pt02#ch09" title="Link target outside of Sample">9. Stocking Away Your Cash</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber"><span href="#/ruleyourfreakinretirement_pt02#ch10" title="Link target outside of Sample">10. Mutual Funds—The Good, the Mediocre, and the Downright Horrible</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber"><span href="#/ruleyourfreakinretirement_pt02#ch11" title="Link target outside of Sample">11. Bonds and Bond Funds</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber"><span href="#/ruleyourfreakinretirement_pt02#ch12" title="Link target outside of Sample">12. The Almighty Buck</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber"><span href="#/ruleyourfreakinretirement_pt02#ch13" title="Link target outside of Sample">13. Asset Allocation</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber1"><span href="#/ruleyourfreakinretirement_pt03#pt03" title="Link target outside of Sample"><span class="bold">Part III: Making the Most of It</span></span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber"><span href="#/ruleyourfreakinretirement_pt03#ch14" title="Link target outside of Sample">14. Looking to Trends</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber"><span href="#/ruleyourfreakinretirement_pt03#ch15" title="Link target outside of Sample">15. Trading the Gaps</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber"><span href="#/ruleyourfreakinretirement_pt03#ch16" title="Link target outside of Sample">16. Trading Options for Retirement</span></p></div>
<br/><br/>
<div class="contentsEntry">
<p class="contentsEntryName"><span href="#/ruleyourfreakinretirement_bm01#bm01" title="Link target outside of Sample">Conclusion</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryName"><span href="#/ruleyourfreakinretirement_bm02#bm02" title="Link target outside of Sample">Glossary</span></p></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ruleyourfreakinretirement_con01.vue?558c5bd7